import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import homeIcon from '@assets/pictures/svgs/home.svg';
import activehomeIcon from '@assets/pictures/svgs/home-active.svg';
import moviesIcon from '@assets/pictures/svgs/movies.svg';
import activeMoviesIcon from '@assets/pictures/svgs/movies-active.svg';
// import transactionIcon from "@assets/pictures/svgs/transaction.svg";
import transactionIcon from '@assets/pictures/svgs/firework.svg';
// import activeTransactionIcon from "@assets/pictures/svgs/transaction-active.svg";
import activeTransactionIcon from '@assets/pictures/svgs/firework-active.svg';
import profileIcon from '@assets/pictures/svgs/profile1.svg';
import activeProfileIcon from '@assets/pictures/svgs/profile1-active.svg';
import { motion } from 'framer-motion';
export default function MobileBottomMenu(props) {
  const history = useHistory();

  const miniFestivalsData = useSelector((state) => state.homepage.miniFestivals);

  let activeIcon = null;

  const { pathname } = useLocation();
  if (pathname === '/') {
    activeIcon = 'home';
  } else if (pathname === '/schedules') {
    activeIcon = 'schedules';
  } else if (
    pathname === '/mini-festivals' &&
    miniFestivalsData?.Records?.length > 0
  ) {
    activeIcon = 'pno';
  } else if (pathname === '/menu') {
    activeIcon = 'menu';
  }

  return (
    activeIcon && (
      <section className="mobile-bottom-menu d-block d-md-none">
        <div className="d-flex justify-content-around align-items-center h-100">
          <div
            className={`menu-icon ${activeIcon === 'home' ? 'active' : ''}`}
            onClick={() => {
              if (window.location.pathname === `/mini-festivals`) {
                history.push(`/`);
                // window.location.reload();
              } else {
                history.push(`/`);
              }
            }}
          >
            {activeIcon !== 'home' ? (
              <svg
                width="26"
                height="24"
                viewBox="0 0 26 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.8809 11.8092L14.3152 1.24899L13.607 0.540792C13.4457 0.380493 13.2275 0.290527 13 0.290527C12.7726 0.290527 12.5543 0.380493 12.393 0.540792L1.11916 11.8092C0.953812 11.9739 0.823137 12.17 0.734846 12.386C0.646554 12.6021 0.602436 12.8336 0.605094 13.067C0.616031 14.0295 1.4172 14.7978 2.3797 14.7978H3.54181V23.7037H22.4582V14.7978H23.6449C24.1125 14.7978 24.5527 14.6146 24.8836 14.2838C25.0465 14.1214 25.1756 13.9283 25.2634 13.7157C25.3511 13.503 25.3959 13.2751 25.3949 13.0451C25.3949 12.5802 25.2117 12.14 24.8809 11.8092ZM14.5313 21.7349H11.4688V16.1568H14.5313V21.7349ZM20.4895 12.8291V21.7349H16.2813V15.5006C16.2813 14.8963 15.7918 14.4068 15.1875 14.4068H10.8125C10.2082 14.4068 9.71877 14.8963 9.71877 15.5006V21.7349H5.51056V12.8291H2.88556L13.0027 2.72009L13.6344 3.35173L23.1172 12.8291H20.4895Z"
                  fill="white"
                />
              </svg>
            ) : (
              <svg
                width="26"
                height="24"
                viewBox="0 0 26 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.8809 11.809L14.3152 1.24887L13.607 0.540669C13.4457 0.380371 13.2275 0.290405 13 0.290405C12.7726 0.290405 12.5543 0.380371 12.393 0.540669L1.11916 11.809C0.953812 11.9737 0.823137 12.1699 0.734846 12.3859C0.646554 12.6019 0.602436 12.8335 0.605094 13.0668C0.616031 14.0293 1.4172 14.7977 2.3797 14.7977H3.54181V23.7036H22.4582V14.7977H23.6449C24.1125 14.7977 24.5527 14.6145 24.8836 14.2836C25.0465 14.1212 25.1756 13.9282 25.2634 13.7155C25.3511 13.5029 25.3959 13.275 25.3949 13.045C25.3949 12.5801 25.2117 12.1399 24.8809 11.809ZM14.5313 21.7348H11.4688V16.1567H14.5313V21.7348ZM20.4895 12.8289V21.7348H16.2813V15.5004C16.2813 14.8961 15.7918 14.4067 15.1875 14.4067H10.8125C10.2082 14.4067 9.71877 14.8961 9.71877 15.5004V21.7348H5.51056V12.8289H2.88556L13.0027 2.71997L13.6344 3.35161L23.1172 12.8289H20.4895Z"
                  fill="#e8308a"
                />
              </svg>
            )}
          </div>

          {miniFestivalsData?.Records?.length > 0 && (
            <div
              className={`menu-icon fest ${activeIcon === 'pno' ? 'active' : ''}`}
              onClick={() => {
                history.push('/mini-festivals');
              }}
            >
              {activeIcon !== 'pno' ? (
                <svg
                  width="26"
                  height="30"
                  viewBox="0 0 26 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.82812 6.5C5.68203 6.5 5.5625 6.61953 5.5625 6.76562V8.35938C5.5625 8.50547 5.68203 8.625 5.82812 8.625H18.5781C18.7242 8.625 18.8438 8.50547 18.8438 8.35938V6.76562C18.8438 6.61953 18.7242 6.5 18.5781 6.5H5.82812ZM12.2031 13.1406V11.5469C12.2031 11.4008 12.0836 11.2812 11.9375 11.2812H5.82812C5.68203 11.2812 5.5625 11.4008 5.5625 11.5469V13.1406C5.5625 13.2867 5.68203 13.4062 5.82812 13.4062H11.9375C12.0836 13.4062 12.2031 13.2867 12.2031 13.1406ZM10.6094 26.2891H2.90625V2.91406H21.5V14.3359C21.5 14.482 21.6195 14.6016 21.7656 14.6016H23.625C23.7711 14.6016 23.8906 14.482 23.8906 14.3359V1.58594C23.8906 0.998242 23.4158 0.523438 22.8281 0.523438H1.57812C0.99043 0.523438 0.515625 0.998242 0.515625 1.58594V27.6172C0.515625 28.2049 0.99043 28.6797 1.57812 28.6797H10.6094C10.7555 28.6797 10.875 28.5602 10.875 28.4141V26.5547C10.875 26.4086 10.7555 26.2891 10.6094 26.2891ZM14.0658 22.4508C14.1256 21.3053 14.6037 20.2328 15.4205 19.416C16.2904 18.5461 17.4791 18.0547 18.7109 18.0547C19.9527 18.0547 21.1215 18.5395 22.0014 19.416C22.1076 19.5223 22.2105 19.6352 22.3068 19.7514L21.5398 20.3457C21.5003 20.3763 21.4702 20.4174 21.453 20.4644C21.4358 20.5113 21.4322 20.5622 21.4426 20.6111C21.453 20.66 21.477 20.705 21.5118 20.7408C21.5466 20.7767 21.5909 20.802 21.6395 20.8139L24.7373 21.5609C24.9033 21.6008 25.0627 21.4746 25.066 21.3053L25.0859 18.1377C25.0864 18.0878 25.0728 18.0388 25.0467 17.9962C25.0206 17.9537 24.9831 17.9194 24.9384 17.8972C24.8937 17.875 24.8436 17.8659 24.794 17.8708C24.7443 17.8758 24.6971 17.8946 24.6576 17.9252L23.9836 18.4498C22.7418 16.9125 20.8393 15.9297 18.7109 15.9297C15.0619 15.9297 12.0836 18.815 11.9375 22.4275C11.9309 22.577 12.0537 22.7031 12.2031 22.7031H13.8002C13.943 22.7031 14.0592 22.5936 14.0658 22.4508ZM25.2188 22.7031H23.6217C23.4789 22.7031 23.3627 22.8127 23.3561 22.9555C23.2963 24.101 22.8182 25.1734 22.0014 25.9902C21.1314 26.8602 19.9428 27.3516 18.7109 27.3516C17.4691 27.3516 16.3004 26.8668 15.4205 25.9902C15.3143 25.884 15.2113 25.7711 15.115 25.6549L15.882 25.0605C15.9216 25.03 15.9517 24.9888 15.9689 24.9419C15.9861 24.8949 15.9897 24.8441 15.9793 24.7952C15.9689 24.7463 15.9449 24.7013 15.9101 24.6654C15.8752 24.6295 15.831 24.6042 15.7824 24.5924L12.6846 23.8453C12.5186 23.8055 12.3592 23.9316 12.3559 24.101L12.3359 27.2686C12.3355 27.3185 12.349 27.3675 12.3751 27.41C12.4012 27.4525 12.4388 27.4869 12.4835 27.509C12.5282 27.5312 12.5782 27.5404 12.6279 27.5354C12.6776 27.5305 12.7248 27.5116 12.7643 27.4811L13.4383 26.9564C14.6801 28.4937 16.5826 29.4766 18.7109 29.4766C22.36 29.4766 25.3383 26.5912 25.4844 22.9787C25.491 22.8293 25.3682 22.7031 25.2188 22.7031Z"
                    fill="white"
                  />
                </svg>
              ) : (
                <svg
                  width="22"
                  height="24"
                  viewBox="0 0 22 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M5.09375 5C4.97344 5 4.875 5.09844 4.875 5.21875V6.53125C4.875 6.65156 4.97344 6.75 5.09375 6.75H15.5938C15.7141 6.75 15.8125 6.65156 15.8125 6.53125V5.21875C15.8125 5.09844 15.7141 5 15.5938 5H5.09375ZM10.3438 10.4688V9.15625C10.3438 9.03594 10.2453 8.9375 10.125 8.9375H5.09375C4.97344 8.9375 4.875 9.03594 4.875 9.15625V10.4688C4.875 10.5891 4.97344 10.6875 5.09375 10.6875H10.125C10.2453 10.6875 10.3438 10.5891 10.3438 10.4688ZM9.03125 21.2969H2.6875V2.04688H18V11.4531C18 11.5734 18.0984 11.6719 18.2188 11.6719H19.75C19.8703 11.6719 19.9688 11.5734 19.9688 11.4531V0.953125C19.9688 0.469141 19.5777 0.078125 19.0938 0.078125H1.59375C1.10977 0.078125 0.71875 0.469141 0.71875 0.953125V22.3906C0.71875 22.8746 1.10977 23.2656 1.59375 23.2656H9.03125C9.15156 23.2656 9.25 23.1672 9.25 23.0469V21.5156C9.25 21.3953 9.15156 21.2969 9.03125 21.2969ZM11.8777 18.1359C11.927 17.1926 12.3207 16.3094 12.9934 15.6367C13.7098 14.9203 14.6887 14.5156 15.7031 14.5156C16.7258 14.5156 17.6883 14.9148 18.4129 15.6367C18.5004 15.7242 18.5852 15.8172 18.6645 15.9129L18.0328 16.4023C18.0002 16.4275 17.9754 16.4614 17.9613 16.5001C17.9471 16.5387 17.9441 16.5806 17.9527 16.6209C17.9613 16.6612 17.981 16.6982 18.0097 16.7277C18.0384 16.7573 18.0748 16.7781 18.1148 16.7879L20.666 17.4031C20.8027 17.4359 20.934 17.332 20.9367 17.1926L20.9531 14.584C20.9535 14.5429 20.9423 14.5025 20.9208 14.4675C20.8993 14.4325 20.8684 14.4042 20.8316 14.3859C20.7948 14.3677 20.7536 14.3601 20.7127 14.3642C20.6718 14.3683 20.6329 14.3838 20.6004 14.409L20.0453 14.841C19.0227 13.575 17.4559 12.7656 15.7031 12.7656C12.698 12.7656 10.2453 15.1418 10.125 18.1168C10.1195 18.2398 10.2207 18.3438 10.3438 18.3438H11.659C11.7766 18.3438 11.8723 18.2535 11.8777 18.1359ZM21.0625 18.3438H19.7473C19.6297 18.3438 19.534 18.434 19.5285 18.5516C19.4793 19.4949 19.0855 20.3781 18.4129 21.0508C17.6965 21.7672 16.7176 22.1719 15.7031 22.1719C14.6805 22.1719 13.718 21.7727 12.9934 21.0508C12.9059 20.9633 12.8211 20.8703 12.7418 20.7746L13.3734 20.2852C13.406 20.26 13.4308 20.2261 13.445 20.1874C13.4591 20.1488 13.4621 20.1069 13.4536 20.0666C13.445 20.0263 13.4252 19.9893 13.3965 19.9598C13.3679 19.9302 13.3314 19.9094 13.2914 19.8996L10.7402 19.2844C10.6035 19.2516 10.4723 19.3555 10.4695 19.4949L10.4531 22.1035C10.4527 22.1446 10.4639 22.185 10.4854 22.22C10.5069 22.255 10.5378 22.2833 10.5746 22.3016C10.6115 22.3198 10.6527 22.3274 10.6936 22.3233C10.7345 22.3192 10.7734 22.3037 10.8059 22.2785L11.3609 21.8465C12.3836 23.1125 13.9504 23.9219 15.7031 23.9219C18.7082 23.9219 21.1609 21.5457 21.2812 18.5707C21.2867 18.4477 21.1855 18.3438 21.0625 18.3438Z"
                    fill="#E8308A"
                  />
                </svg>
              )}
            </div>
          )}
          <div
            className={`menu-icon ${activeIcon === 'menu' ? 'active' : ''}`}
            onClick={() => {
              history.push('/menu');
            }}
          >
            {activeIcon !== 'menu' ? (
              <svg
                width="26"
                height="28"
                viewBox="0 0 26 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M24.5055 22.3539C23.8791 20.8703 22.9702 19.5227 21.8293 18.3861C20.6919 17.2463 19.3445 16.3375 17.8615 15.71C17.8482 15.7033 17.8349 15.7 17.8217 15.6934C19.8902 14.1992 21.2349 11.7654 21.2349 9.01953C21.2349 4.4707 17.5494 0.785156 13.0006 0.785156C8.45174 0.785156 4.7662 4.4707 4.7662 9.01953C4.7662 11.7654 6.11092 14.1992 8.17948 15.6967C8.1662 15.7033 8.15292 15.7066 8.13964 15.7133C6.65213 16.3408 5.31737 17.2406 4.17186 18.3895C3.03203 19.5269 2.12324 20.8743 1.49569 22.3572C0.87918 23.809 0.546683 25.3656 0.516196 26.9426C0.51531 26.978 0.521526 27.0133 0.534477 27.0463C0.547429 27.0793 0.566854 27.1093 0.591609 27.1347C0.616363 27.1601 0.645946 27.1802 0.678613 27.194C0.711281 27.2078 0.746373 27.2149 0.781821 27.2148H2.77401C2.9201 27.2148 3.03631 27.0986 3.03963 26.9559C3.10604 24.3926 4.13534 21.992 5.95487 20.1725C7.83749 18.2898 10.3377 17.2539 13.0006 17.2539C15.6635 17.2539 18.1637 18.2898 20.0463 20.1725C21.8658 21.992 22.8951 24.3926 22.9615 26.9559C22.9648 27.102 23.081 27.2148 23.2271 27.2148H25.2193C25.2548 27.2149 25.2899 27.2078 25.3225 27.194C25.3552 27.1802 25.3848 27.1601 25.4095 27.1347C25.4343 27.1093 25.4537 27.0793 25.4667 27.0463C25.4796 27.0133 25.4858 26.978 25.4849 26.9426C25.4517 25.3555 25.123 23.8115 24.5055 22.3539ZM13.0006 14.7305C11.4765 14.7305 10.0422 14.1361 8.96307 13.057C7.88397 11.9779 7.28963 10.5436 7.28963 9.01953C7.28963 7.49551 7.88397 6.06113 8.96307 4.98203C10.0422 3.90293 11.4765 3.30859 13.0006 3.30859C14.5246 3.30859 15.959 3.90293 17.0381 4.98203C18.1172 6.06113 18.7115 7.49551 18.7115 9.01953C18.7115 10.5436 18.1172 11.9779 17.0381 13.057C15.959 14.1361 14.5246 14.7305 13.0006 14.7305Z"
                  fill="white"
                />
              </svg>
            ) : (
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20.4749 17.8797C19.9591 16.6579 19.2106 15.5481 18.271 14.6121C17.3343 13.6734 16.2247 12.925 15.0034 12.4082C14.9925 12.4027 14.9816 12.4 14.9706 12.3945C16.6741 11.1641 17.7816 9.15977 17.7816 6.89844C17.7816 3.15234 14.7464 0.117188 11.0003 0.117188C7.25422 0.117188 4.21906 3.15234 4.21906 6.89844C4.21906 9.15977 5.32648 11.1641 7.03 12.3973C7.01906 12.4027 7.00813 12.4055 6.99719 12.4109C5.77219 12.9277 4.67297 13.6688 3.72961 14.6148C2.79092 15.5516 2.04251 16.6612 1.5257 17.8824C1.01799 19.078 0.744169 20.3599 0.719063 21.6586C0.718333 21.6878 0.723452 21.7168 0.734118 21.744C0.744784 21.7712 0.760781 21.7959 0.781167 21.8168C0.801553 21.8377 0.825915 21.8543 0.852818 21.8657C0.879721 21.877 0.90862 21.8828 0.937813 21.8828H2.57844C2.69875 21.8828 2.79445 21.7871 2.79719 21.6695C2.85188 19.5586 3.69953 17.5816 5.19797 16.0832C6.74836 14.5328 8.80735 13.6797 11.0003 13.6797C13.1933 13.6797 15.2523 14.5328 16.8027 16.0832C18.3011 17.5816 19.1488 19.5586 19.2034 21.6695C19.2062 21.7898 19.3019 21.8828 19.4222 21.8828H21.0628C21.092 21.8828 21.1209 21.877 21.1478 21.8657C21.1747 21.8543 21.1991 21.8377 21.2195 21.8168C21.2398 21.7959 21.2558 21.7712 21.2665 21.744C21.2772 21.7168 21.2823 21.6878 21.2816 21.6586C21.2542 20.3516 20.9835 19.0801 20.4749 17.8797ZM11.0003 11.6016C9.74524 11.6016 8.56399 11.1121 7.67531 10.2234C6.78664 9.33477 6.29719 8.15352 6.29719 6.89844C6.29719 5.64336 6.78664 4.46211 7.67531 3.57344C8.56399 2.68477 9.74524 2.19531 11.0003 2.19531C12.2554 2.19531 13.4366 2.68477 14.3253 3.57344C15.214 4.46211 15.7034 5.64336 15.7034 6.89844C15.7034 8.15352 15.214 9.33477 14.3253 10.2234C13.4366 11.1121 12.2554 11.6016 11.0003 11.6016Z"
                  fill="#E8308A"
                />
              </svg>
            )}
          </div>
        </div>
      </section>
    )
  );
}

{
  /* <section className="mobile-bottom-menu d-block d-md-none">
        <div className="d-flex justify-content-around align-items-center h-100">
          <div
            className="menu-icon"
            onClick={() => {
              if (window.location.pathname === `/mini-festivals`) {
                history.push(`/`);
                // window.location.reload();
              } else {
                history.push(`/`);
              }
            }}
          >
            <img
              src={activeIcon !== "home" ? homeIcon : activehomeIcon}
              alt="home"
            />
          </div>
          <div
            className="menu-icon"
            onClick={() => {

            }}
          >
            <img
              src={activeIcon !== "schedules" ? moviesIcon : activeMoviesIcon}
              alt="schedules"
            />
          </div>
          <div
            className="menu-icon fest"
            onClick={() => {
              history.push("/mini-festivals");
            }}
          >
            <img
              src={
                activeIcon !== "pno" ? transactionIcon : activeTransactionIcon
              }
              alt="Mini Festivals"
            />
          </div>
          <div
            className="menu-icon"
            onClick={() => {
              history.push("/menu");
            }}
          >
            <img
              src={activeIcon !== "menu" ? profileIcon : activeProfileIcon}
              alt="home"
            />
          </div>
        </div>
      </section> */
}
